import ufeApi from 'services/api/ufeApi';

export const addProductsToCart = ({ orderId = 'current', skuList = [] }) => {
    const requestUrl = '/api/shopping-cart/basket/items';

    return ufeApi.makeRequest(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ orderId, skuList })
    });
};

export const addBIRewardsToCart = data => {
    const requestUrl = '/api/bi/profile/rewards';

    return ufeApi.makeRequest(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
};

export const addSampleTocart = data => {
    const requestUrl = '/api/shopping-cart/basket/samples';

    return ufeApi.makeRequest(requestUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
};

const isBiReward = product => {
    return product && !!product.biType && product.biType.toLowerCase() !== 'none';
};

const isSample = product => {
    return product.type === 'Sample';
};

export const addToCart = product => {
    if (isBiReward(product)) {
        return addBIRewardsToCart({
            biRewards: [product.skuId],
            biRewardsList: [{ skuId: product.skuId, productId: product.primaryProduct?.productId }]
        });
    }

    if (isSample(product)) {
        return addSampleTocart({
            sampleSkuIdList: [product.skuId],
            sampleSkuList: [{ skuId: product.skuId, productId: product.primaryProduct?.productId }]
        });
    }

    return addProductsToCart({
        skuList: [
            {
                isAcceptTerms: false,
                qty: 1,
                replenishmentSelected: false,
                replenishmentFrequency: '',
                skuId: product.skuId
            }
        ]
    });
};
